import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "todo" }
const _hoisted_2 = { class: "todo-bar" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "title-header" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-regular fa-bookmark" }),
  /*#__PURE__*/_createElementVNode("h1", null, "TaskManager")
], -1)

import { onMounted, ref, watch } from 'vue';

import Modal from './components/Modal.vue';
import TodoList from './components/TodoList.vue';
import { useModal } from './composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { isOpenModal } = useModal();
const isDarkModeActive = ref<boolean>();

onMounted(() => {
  const darkMode = localStorage.getItem('darkMode');
  if (darkMode) {
    isDarkModeActive.value = JSON.parse(darkMode);
  }
});

watch(isDarkModeActive, (value) => {
  if (value) {
    document.body.classList.add('todo-darkmode');
  } else {
    document.body.classList.remove('todo-darkmode');
  }
});

const setDarkMode = () => {
  isDarkModeActive.value = !isDarkModeActive.value;
  localStorage.setItem('darkMode', JSON.stringify(isDarkModeActive.value));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!isDarkModeActive.value)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "fa-solid fa-lightbulb",
            onClick: setDarkMode
          }))
        : (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: "fa-regular fa-lightbulb",
            onClick: setDarkMode
          }))
    ]),
    _createVNode(TodoList),
    (_unref(isOpenModal) === true)
      ? (_openBlock(), _createBlock(Modal, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}
}

})